// extracted by mini-css-extract-plugin
module.exports = {"footer":"ForgotPasswordModal_footer__3T-E_","label":"ForgotPasswordModal_label__1sxkA"};